<template>
  <el-dialog
    :title="$t('systemGoldSetting.editTitle')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose">
    <el-form
      :model="formData"
      label-width="120px"
      ref="editForm"
      :rules="rules">
      <el-form-item
        :label="$t('systemGoldSetting.goldName')"
        prop="goldName">
        <el-input v-model="formData.goldName"></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('systemGoldSetting.goldType')"
        prop="goldType">
        <el-input v-model="formData.goldType"></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('systemGoldSetting.buyPrice')"
        prop="buyPrice">
        <el-input v-model="formData.buyPrice"></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('systemGoldSetting.usePrice')"
        prop="usePrice">
        <el-input v-model="formData.usePrice"></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('systemGoldSetting.validity')"
        prop="validity">
        <el-input v-model="formData.validity"></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('systemGoldSetting.state')"
        prop="state">
        <el-input v-model="formData.state"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="submitForm">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'EditSystemGoldSetting',
  data() {
    return {
      dialogVisible: false,
      formData: {
        settingId: '',
        goldName: '',
        goldType: '',
        buyPrice: '',
        usePrice: '',
        validity: '',
        state: ''
      },
      rules: {
        goldName: [
          { required: true, message: this.$t('systemGoldSetting.rules.goldNameRequired'), trigger: 'blur' }
        ],
        goldType: [
          { required: true, message: this.$t('systemGoldSetting.rules.goldTypeRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(data) {
      if (data) {
        this.formData = Object.assign({}, data)
      } else {
        this.resetForm()
      }
      this.dialogVisible = true
    },
    resetForm() {
      this.formData = {
        settingId: '',
        goldName: '',
        goldType: '',
        buyPrice: '',
        usePrice: '',
        validity: '',
        state: ''
      }
    },
    handleClose() {
      this.$refs.editForm.resetFields()
    },
    submitForm() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$emit('submit', this.formData)
          this.dialogVisible = false
        }
      })
    }
  }
}
</script>